import { pushToDataLayer } from '../../../../../services/gtmService';

import {
  calculateTimeSpentInMilliseconds,
  removeStartTime,
} from '../../../../../helpers/browserStorageTimer';

import { FINANCE_APPLICATION_START_TIME } from '../../../../../components/CarFinancePage/constants';

import { type ApplicationTrackingArgs, RESULT } from './tracking.typed';

export const onSubmitTrackingEvent = (args: ApplicationTrackingArgs) => {
  const { result, provider, errorFields = null } = args;

  pushToDataLayer({
    event: 'finance_application_submit',
    result,
    errors: errorFields,
    time:
      calculateTimeSpentInMilliseconds(FINANCE_APPLICATION_START_TIME) / 1000,
    finance_provider: provider,
  });

  if (result === RESULT.SUCCESS) {
    removeStartTime(FINANCE_APPLICATION_START_TIME);
  }
};
